import { FieldType } from '@selfai-platform/pipeline-shared';
import { TypeFieldValues } from '../models';

export function typeFieldIsNotEmpty(valueObj: unknown): boolean {
  return valueObj !== null && typeof valueObj === 'object' && Object.keys(valueObj).length > 0;
}

export function normalizeTypeField<T extends TypeFieldValues>(valueObj: T, defaultFieldType: FieldType): T {
  if (FieldType.JSONPATH in valueObj) {
    return {
      type: FieldType.JSONPATH,
      value: valueObj[FieldType.JSONPATH] as string,
    } as T;
  }

  if (FieldType.SPEL in valueObj) {
    return {
      type: FieldType.SPEL,
      value: valueObj[FieldType.SPEL] as string,
    } as T;
  }

  if (FieldType.CONSTANT in valueObj) {
    return {
      type: FieldType.CONSTANT,
      value: valueObj[FieldType.CONSTANT] as string,
    } as T;
  }

  // some times backend can send empty object
  return !valueObj?.type
    ? ({ type: defaultFieldType, value: '' } as T)
    : ({ type: valueObj.type, value: valueObj.value || '' } as T);
}
